// Mapping of Acxiom vendor-locked codes (e.g., AI, AN, BF) to internal property names.
// The raw keys (e.g., AI, AN) come directly from Acxiom and should not be changed.
// The mapped keys (e.g., a_age, a_haschildren) follow our internal naming convention (prefix 'a_' for Acxiom traits).

(function acxiomDataHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  const previousAcxiomDataHandlerModule = global.NewHomeSource.Modules.acxiomDataHandler;
  const cookieHandler = global.NewHomeSource.Modules.cookieHandler;
  const acxiomLabelMapper = global.NewHomeSource.Modules.acxiomLabelMapper;
  const storage = global.sessionStorage;
  const acxiomDomain = 'https://ri.ax5.co';

  /**
   * Saves the Acxiom data to sessionStorage under the key 'ridata'.
   * @param {Object} acxiomData - The Acxiom data to be stored.
   */
  function saveDataToSessionStorage(acxiomData) {
    storage.setItem('ridata', acxiomData);
  }

  /**
   * Saves the Acxiom data to a cookie named 'ri_data'.
   * @param {Object} acxiomData - The Acxiom data to be stored.
   */
  function saveDataToCookieStorage(acxiomData) {
    const serialized = encodeURIComponent(acxiomData);
    cookieHandler.createCookie('ri_data', serialized);
  }

  /**
   * Retrieves the raw Acxiom data from sessionStorage or cookies.
   * @returns {string|null} The raw Acxiom data as a string if found, otherwise null.
   */
  function getRawAcxiomData() {
    const sessionData = storage.getItem('ridata');
    if (sessionData) {
      return JSON.parse(sessionData);
    }

    const cookieData = cookieHandler.readCookie('ri_data');
    if (cookieData) {
      const decodedCookieData = decodeURIComponent(cookieData);
      return JSON.parse(decodedCookieData);
    }

    return null;
  }

  /**
   * @constructs NewHomeSource.Modules.acxiomDataHandler
   */
  function AcxiomDataHandler() {}

  /**
   * Gets the Acxiom tracking data from sessionStorage or cookies.
   * @public
   */
  AcxiomDataHandler.getAcxiomTrackingProperties = function getAcxiomTrackingProperties() {
    const rawData = getRawAcxiomData();
    const trackingProperties = acxiomLabelMapper.mapAcxiomTrackingProperties(rawData);
    return trackingProperties;
  };

  /**
   * Restores the previous Acxiom tracking module if it exists.
   * @public
   */
  AcxiomDataHandler.noConflict = function noConflict() {
    global.NewHomeSource.Modules.acxiomDataHandler = previousAcxiomDataHandlerModule;
    return AcxiomDataHandler;
  };

  /**
   * Listens for a message from Acxiom and stores the data.
   * You can disable this call if integration is not immediate.
   */
  function acxiomMessageHandler(event) {
    if (event.origin !== acxiomDomain) { return; }

    const acxiomData = event.data && event.data.ri_response;

    // acxiom third-party script sends 'undefined' as a string when no data is available.
    if (!acxiomData || acxiomData === 'undefined') { return; }

    saveDataToSessionStorage(acxiomData);
    saveDataToCookieStorage(acxiomData);
    window.removeEventListener('message', acxiomMessageHandler);

    document.dispatchEvent(new CustomEvent('acxiom-data-saved'));
  }

  window.addEventListener('message', acxiomMessageHandler);
  global.NewHomeSource.Modules.acxiomDataHandler = AcxiomDataHandler;
}(window));
